<template>
  <el-dialog
    ref="dialog"
    title=""
    size="large"
    :before-close="handleClose"
    @close="closeDialog"
    style="min-width:1200px">
    <form-render
      :contentId="source.contentId"
      :dealId="source.dealId"
      :dataId="source.dataId"
      :ids="source.ids"
      @saveCallback="saveCallback"
      :isDialog="true"
      @closeDialog="closeDialog"
      v-if="show"></form-render>
  </el-dialog>
</template>

<script>
  import formRender from '../formRender'
  export default {
    props: {
      source: {
        type: Object,
        default() {
          return { contentId: '', dealId: '', dataId: '', ids: null }
        }
      }
    },
    data() {
      return {
        show: false
      }
    },
    methods: {
      openDialog() {
        this.$refs.dialog.open()
        this.show = true
      },
      closeDialog() {
        this.$refs.dialog.close()
        this.show = false
      },
      saveCallback(isSuccess, res) {
        if (isSuccess) {
          setTimeout(() => {
            this.closeDialog()
          }, 500)
          this.$emit('editCallback', true, res)
        }
      }
    },
    components: {
      formRender
    }
  }
</script>


// WEBPACK FOOTER //
// editDeal.vue?02eb58b9